enum userType{
    GET_ALL_USER_START='GET_ALL_USER_START',
    GET_ALL_USER_SUCCESS = 'GET_ALL_USER_SUCCESS',
    GET_ALL_USER_ERROR = 'GET_ALL_USER_ERROR',
    DELETE_USER_START='DELETE_USER_START',
    DELETE_USER_SUCCESS='DELETE_USER_SUCCESS',
    DELETE_USER_ERROR = 'DELETE_USER_ERROR',
    RESET_DELETE_USER_STATE = 'RESET_DELETE_USER_STATE',
    ADD_USER_START='ADD_USER_START',
    ADD_USER_SUCCESS='ADD_USER_SUCCESS',
    ADD_USER_ERROR='ADD_USER_ERROR',
    RESET_ADD_USER_STATE='RESET_ADD_USER_STATE',
    GET_USER_BY_ID_START='GET_USER_BY_ID_START',
    GET_USER_BY_ID_SUCCESS='GET_USER_BY_ID_SUCCESS',
    GET_USER_BY_ID_ERROR='GET_USER_BY_ID_ERROR',
    RESET_GET_USER_BY_ID_STATE='RESET_GET_USER_BY_ID_STATE',
    GET_USER_DEVICES_START = 'GET_USER_DEVICES_START',
    GET_USER_DEVICES_SUCCESS = 'GET_USER_DEVICES_SUCCESS',
    GET_USER_DEVICES_ERROR = 'GET_USER_DEVICES_ERROR',
    RESET_USER_DEVICES_STATE = 'RESET_USER_DEVICES_STATE'
}

export default userType;